import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import StepperCustom from '../../../components/step/Stepper';
import { EvidencePayment, FileApplicant, FormApplicant, TermPayment } from '../list-applicants/applicent-detail';
import ContainerButton from '../../../components/button/ContainerButton';
import { Box, Typography } from '@mui/material';
import StateComponents from '../../../components/state-component/StateComponents';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { AdmissionFrontApi } from '../../../api/admission-front/admission-front.api';
import moment from 'moment';
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal';
import { InterviewStudentApi } from '../../../api/interview-student/interview-student.api';
import { AdmissionAdminApi } from '../../../api/admission_admin/admission_admin.api';
import ModalCustom from '../../../components/modal/ModalCustom';
import { ButtonContained } from '../../../components/button/ButtonCustoms';

export default function TermPaymentDetail() {
    const { t } = useTranslation();
    const { id } = useParams()
    const dispatch = useDispatch();
    const fileRef = useRef<any>()

    const navigate: NavigateFunction = useNavigate();
    const [showModal, setShowModal] = useState<string>("");


    const [form, setForm] = useState<any>();
    const [file, setFile] = useState<any>();
    const [remark, set_remark] = useState<any>();
    const [formInterview, setFormInterview] = useState<any>();
    const [tabStep, setTebStep] = useState(0);
    const allStep = form?.admission_student_term_payment ? [
        {
            name: t("TERM_PAYMENT_APPLICANT_PERSONAL_INFO"),
            isAccept: false,
            icon: null
        },
        {
            name: t("TERM_PAYMENT_APPLICATION_PAYMENT_PROOF"),
            isAccept: false,
            icon: null
        },
        {
            name: t("TERM_PAYMENT_TUITION_PAYMENT_PROOF"),
            isAccept: false,
            icon: null
        },

    ] : [
        {
            name: t("TERM_PAYMENT_APPLICANT_PERSONAL_INFO"),
            isAccept: false,
            icon: null
        },
        {
            name: t("TERM_PAYMENT_APPLICATION_PAYMENT_PROOF"),
            isAccept: false,
            icon: null
        },

    ];
    const handleCloseModal = () => {
        setShowModal("");
        set_remark('')
        setFile(null)
    }
    const getDetail = async () => {
        dispatch(setLoading());

        await AdmissionFrontApi.findOne(id).then((res) => {
            if (res.status < 300) {
                setForm(res.data.data)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    useEffect(() => {
        getDetail()
    }, [])

    // const handleSubmit = async () => {
    //     const body = [{
    //         ...formInterview,
    //         id_admission_student: id
    //     }]
    //     dispatch(setLoading());
    //     if (id) {
    //         await InterviewStudentApi.createInterviewStudent(body)
    //             .then((res) => {
    //                 if (res.status < 300) {
    //                     alertSuccess("บันทึก", "บันทึก เรียบร้อย");
    //                     // navigate(routeName.admission.ManagePayment)
    //                 }
    //             })
    //             .catch((err) => {
    //                 console.log(err);
    //                 alertError("บันทึก", "บันทึก ไม่สำเร็จ");
    //             })
    //             .finally(() => {
    //                 dispatch(unsetLoading());
    //             });
    //     }
    // }
    const handleAPPROVE = async () => {
        const formData = new FormData();

        //DRAFT
        formData.append('file', file);
        formData.append('id_admission_student_register_payment ', `${form?.admission_student_term_payment?.id_admission_student_register_payment}`);
        dispatch(setLoading());
        if (id) {
            await AdmissionAdminApi.successPaymentTerm(id, formData)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("TERM_PAYMENT_APPROVE_VERIFICATION"), t("TERM_PAYMENT_APPROVE_VERIFICATION_SUCCESS"), undefined, () => {
                            navigate(routeName.admission.term_payment)
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("TERM_PAYMENT_APPROVE_VERIFICATION"), t("TERM_PAYMENT_APPROVE_VERIFICATION_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }
    }
    const handleReview = async () => {
        const body = {
            admission_status_remark: remark
        }
        dispatch(setLoading());
        if (id) {
            await AdmissionAdminApi.reviewPaymentTerm(id, body)
                .then((res) => {
                    if (res.status < 300) {
                        alertSuccess(t("TERM_PAYMENT_SEND_FOR_REVIEW"), t("TERM_PAYMENT_SEND_FOR_REVIEW_SUCCESS"), undefined, () => {
                            navigate(routeName.admission.term_payment)
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    alertError(t("TERM_PAYMENT_SEND_FOR_REVIEW"), t("TERM_PAYMENT_SEND_FOR_REVIEW_FAILED"));
                })
                .finally(() => {
                    dispatch(unsetLoading());
                });
        }
    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("TERM_PAYMENT_APPLICANT_PERSONAL_INFO")}
                // hidden_sub_title
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "complaintSubmit",
                                name: t("TERM_PAYMENT_ADMISSION_EXAM"),
                                disabled_match: true,
                                pathName: routeName.admission.interview_student
                            },
                            {
                                key: "complaintSubmit",
                                name: t("TERM_PAYMENT_INTERVIEW"),
                                pathName: routeName.admission.interview_student
                            },
                            {
                                key: "complaintSubmit",
                                name: t("TERM_PAYMENT_APPLICANT_PERSONAL_INFO"),
                                pathName: routeName.admission.interview_student_detail
                            },
                        ]}
                    />
                }

                content={
                    <div className='w-full'>
                        <section
                            style={{
                                display: "flex",
                                justifyContent: "start",
                                marginTop: "24px",
                            }}
                        >
                            <StepperCustom
                                step={tabStep}
                                setStep={setTebStep}
                                stepLabel={allStep}
                                view={true}
                            />
                        </section>
                        {tabStep === 0 &&
                            <div style={{ display: 'flex', flexDirection: 'column', gap: "20px" }}>
                                <FormApplicant form={form} />
                                <FileApplicant form={form} />

                            </div>
                        }
                        {tabStep === 1 &&
                            <EvidencePayment form={form} />}
                        {tabStep === 2 &&
                            <> {form?.admission_student_term_payment ? <TermPayment form={form} /> : <Box sx={{ margin: '20px auto', width: "100%" }}><Typography sx={{ color: '#828282' }}>ยังไม่ได้ชำระเงิน</Typography></Box>}</>}
                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => { navigate(-1) },
                                    },
                                    key: "CANCEL",
                                    label: t("TERM_PAYMENT_BACK"),
                                    type: "CANCEL"
                                },

                                // {
                                //     seq: 2,
                                //     hidden: tabStep !== 2,
                                //     buttonProps: {
                                //         onClick: () => {
                                //             handleSubmit()
                                //         }
                                //     },
                                //     key: "NONE",
                                //     label: "ยืนยัน",
                                //     type: 'NONE'
                                // },
                                {
                                    seq: 3,
                                    hidden: form?.admission_status === 'TUITION_PAYMENT_SUCCESS' || tabStep !== 2,
                                    buttonProps: {
                                        onClick: () => {
                                            // alertActive(t("ผ่านการพิจารณา"), t("ต้องการยืนยันการพิจารณา หรือไม่? "), undefined, undefined, async () => {
                                            //     handleAPPROVE('PASS')
                                            // })
                                            setShowModal('SUCCESS')
                                        }
                                    },
                                    key: "APPROVE",
                                    label: t("TERM_PAYMENT_APPROVE_VERIFICATION"),
                                    type: "APPROVE"
                                },
                                {
                                    seq: 4,
                                    hidden: form?.admission_status === 'TUITION_PAYMENT_SUCCESS' || tabStep !== 2,
                                    buttonProps: {
                                        onClick: () => {
                                            // handleSubmit()
                                            // handleAPPROVE()
                                            setShowModal('REVIEW')

                                        }
                                    },
                                    key: "REJECT",
                                    label: t("TERM_PAYMENT_SEND_FOR_REVIEW"),
                                    type: 'REJECT'
                                },
                            ]}
                        />
                    </div>
                }
            />
            {showModal === 'SUCCESS' && (
                <ModalCustom
                    open
                    title={t('TERM_PAYMENT_APPROVE_VERIFICATION')}
                    subTitle={t("TERM_PAYMENT_FILL_ALL_INFO_BEFORE_CONFIRM")}
                    // maxWidth={600}
                    onClose={handleCloseModal}
                    containerButton={{
                        // disabled_submit: !form.gallery_type_name,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleAPPROVE() }
                    }}
                    component={
                        <div className='w-full'>
                            <Box sx={{
                                // boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                padding: "10px 20px",
                                borderRadius: "20px",
                                // height: "500px",
                                border: '1px solid #DDE1EB',
                                cursor: 'pointer'
                            }}>
                                {file ?
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                                        <div>
                                            <Typography sx={{ fontSize: '16px' }}>{file?.name}</Typography>
                                            <Typography>{formatBytes(file?.size)}</Typography>
                                        </div>
                                        <ButtonContained buttonName={t('TERM_PAYMENT_DELETE_FILE')} onClick={() => {
                                            setFile(null)
                                            if (fileRef.current) {
                                                fileRef.current.value = null;
                                            }
                                        }} />

                                    </div>
                                    : <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
                                        <div>
                                            <Typography sx={{ fontSize: '16px' }}>{t('TERM_PAYMENT_SELECT_FILE')}</Typography>
                                            {/* <Typography>{formatBytes(file?.size)}</Typography> */}
                                        </div>
                                        <ButtonContained buttonName={t('TERM_PAYMENT_SELECT_FILE')} onClick={() => { fileRef.current.click() }} />
                                    </div>}

                            </Box>
                            <input ref={fileRef} className='hidden' type='file'
                                accept={"image/*"}
                                onChange={(e: any) => {
                                    setFile(e.target.files[0])
                                    if (fileRef.current) {
                                        fileRef.current.value = null;
                                    }
                                }} />
                        </div>
                    }
                />
            )}
            {showModal === 'REVIEW' && (
                <ModalCustom
                    open
                    title={t("TERM_PAYMENT_SEND_FOR_REVIEW")}
                    subTitle={t("TERM_PAYMENT_ENTER_NOTE")}
                    // maxWidth={600}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !remark,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleReview() }
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={[


                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            // md: 6
                                        },
                                        fieldProps: {
                                            heading: t("TERM_PAYMENT_NOTE"),
                                            onChange: (e) => {
                                                set_remark(e.target.value)
                                            },
                                            value: remark || '',
                                            minRow: 6,
                                            multiline: true,
                                            inputHeight: 'auto'
                                        }
                                    },
                                ]} />
                        </div>
                    }
                />
            )}
        </div>
    )
}
